import { SegmentType } from '@wagon-lib/segments.model'

/*------------------------------------
    Contract Table 
------------------------------------*/
export interface ContractsResponse {
    contracts: Contract[]
}
export interface Contract {
    contractId: string
    contractName?: string
    contractNumber: string
    contractBegin: string // date
    contractEnd: string // date
    contractType: ContractType
    status: ContractExpireStatus
    wagonTypes: SegmentType[]
    hasConnect: boolean
}

export enum ContractType {
    SERVICE = 'SERVICE',
    RENTAL = 'RENTAL',
}

export enum ContractExpireStatus {
    UPCOMING = 'UPCOMING',
    ONGOING = 'ONGOING',
    AUTOMATIC_RENEWAL_IN_LESS_THAN_THREE_MONTHS = 'AUTOMATIC_RENEWAL_IN_LESS_THAN_THREE_MONTHS',
    EXPIRES_IN_LESS_THAN_SIX_MONTHS = 'EXPIRES_IN_LESS_THAN_SIX_MONTHS',
    EXPIRES_IN_LESS_THAN_THREE_MONTHS = 'EXPIRES_IN_LESS_THAN_THREE_MONTHS',
    EXPIRED_BUT_STILL_WAGONS_ASSIGNED = 'EXPIRED_BUT_STILL_WAGONS_ASSIGNED',
    EXPIRED = 'EXPIRED',
}

/*------------------------------------
    Contract Header / Widget
------------------------------------*/

export interface ContractsMetadataResponse {
    contractsCount: number
    notifications: {
        count: number
        level: ContractNotificationLevel
    }[]
}

export interface ContractsMetadata {
    contractsCount: number
    issuesCount: number
    hintsCount: number
}

export interface ContractNotification {
    type: ContractNotificationType
    level: ContractNotificationLevel
}

export enum ContractNotificationType {
    ContractPeriodEnding = 'CONTRACT_PERIOD_ENDING',
    ContractPeriodAutomaticRenewal = 'CONTRACT_PERIOD_AUTOMATIC_RENEWAL',
    ContractExpiredStillWagonAssigned = 'CONTRACT_EXPIRED_BUT_STILL_WAGONS_ASSIGNED',
}

export enum ContractNotificationLevel {
    Alert = 'ALERT',
    Warn = 'WARN',
    Info = 'INFO',
}
